import { useState } from 'react';
import { Download, Eraser, Eye, FileDown, FileText, Trash2 } from 'lucide-react';
import Modal from '../../../components/Modal';
import { useLang } from '../../../LangContext';
import { downloadBlob } from '../../../services/api';
import { statusLabel } from '../../../utils/statusLabel';

// Gönderim listesi ve kanban görünümü tarafından paylaşılan detay modalı:
// statü değiştirme, PDF indirme, dosya temizleme ve gönderimi silme burada yönetilir.
export default function SubmissionDetailModal({ submission, statuses, onClose, onChangeStatus, onClearFiles, onDelete, lang, onUpdated }) {
  const { locale: t } = useLang();
  const st = t.submissions;
  const [clearing, setClearing] = useState(false);
  const [deleting, setDeleting] = useState(false);

  async function updateStatus(statusId) {
    const updated = await onChangeStatus(submission.id, statusId);
    if (updated) onUpdated(updated);
  }

  async function handleClearFiles() {
    if (!window.confirm(st.confirmClear)) return;
    setClearing(true);
    try {
      const updated = await onClearFiles(submission.id);
      if (updated) onUpdated(updated);
    } finally {
      setClearing(false);
    }
  }

  // Yanlış gönderilen formu tamamen sil; başarılıysa modal kapanır (kayıt listeden düşer)
  async function handleDelete() {
    if (!window.confirm(st.confirmDelete)) return;
    setDeleting(true);
    try {
      const removed = await onDelete(submission.id);
      if (removed) onClose();
    } finally {
      setDeleting(false);
    }
  }

  async function handlePdfDownload() {
    try {
      await downloadBlob(`/api/submissions/${submission.id}/pdf?lang=${lang}`, `form-${submission.id}.pdf`);
    } catch {
      window.alert(st.noResults);
    }
  }

  return (
    <Modal title={`${submission.formName} - ${submission.userName}`} onClose={onClose}>
      <div className="form-grid">
        <div className="field">
          <label>{st.statusLabel}</label>
          <select onChange={(event) => updateStatus(event.target.value)} defaultValue="">
            <option value="">{statusLabel(t, submission.statusCode, submission.status)}</option>
            {(statuses || []).map((status) => <option key={status.id} value={status.id}>{statusLabel(t, status.code, status.name)}</option>)}
          </select>
        </div>
        <div className="button-row">
          <button className="btn btn-light" onClick={handlePdfDownload}>
            <FileDown /> {st.downloadPdf}
          </button>
          <button className="btn btn-danger" onClick={handleDelete} disabled={deleting}>
            <Trash2 /> {deleting ? st.deleting : st.deleteSubmission}
          </button>
        </div>
        <div className="detail-stack">
          {submission.values.map((item, index) => (
            <div className="detail-item" key={index}><span>{item.field}</span><strong>{item.value || '-'}</strong></div>
          ))}
          {submission.files.length > 0 && (
            <div className="file-attachments">
              <div className="file-attachments-header">
                <h4>{st.filesTitle(submission.files.length)}</h4>
                <button className="file-clear-btn" onClick={handleClearFiles} disabled={clearing}>
                  <Eraser /> {clearing ? st.clearing : st.clearAllFiles}
                </button>
              </div>
              {submission.files.map((item, index) => (
                <div className="file-attachment" key={index}>
                  <div className="file-attachment-icon"><FileText size={18} /></div>
                  <div className="file-attachment-body">
                    <span className="file-attachment-label">{item.field}</span>
                    <span className="file-attachment-name" title={item.originalFileName}>{item.originalFileName}</span>
                  </div>
                  <span className="file-attachment-size">{Math.round(item.sizeBytes / 1024)} KB</span>
                  <div className="file-attachment-actions">
                    <a className="file-action-btn" href={item.url} target="_blank" rel="noreferrer" title="Önizle"><Eye /></a>
                    <a className="file-action-btn" href={item.downloadUrl || item.url} title="İndir"><Download /></a>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
}
